import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';

class FirstAmericanLogAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'first-american-log';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'firsts/americans/logs';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'startTime',
            'endTime',
            'fileName',
            'source',
            'meta',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {};
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {};
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {};
    }

}

export default FirstAmericanLogAppResource;
